import { Component, ViewChild, AfterViewInit, OnDestroy, } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { ApiService } from '../../../../../shared/services/api.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { Router } from '@angular/router';
import { CommonService } from '../../../../../shared/services/common.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, catchError, debounceTime, distinctUntilChanged, filter, map, merge, of, Subject, Subscription, switchMap, takeUntil } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { PreviewfileComponent } from '../../../previewfile/previewfile.component';
import { MatDialog } from '@angular/material/dialog';
import { CompletedInvoiceList } from '../../../../../shared/models/CompletedInvoiceList';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-completedinvoicelist',
  templateUrl: './completedinvoicelist.component.html',
  styleUrl: './completedinvoicelist.component.css'
})
export class CompletedinvoicelistComponent implements AfterViewInit, OnDestroy {

  private loadDataSubscription: Subscription = new Subscription();
  private destroy$: Subject<void> = new Subject<void>();

  dataSource!: MatTableDataSource<CompletedInvoiceList>
  displayedColumns: string[] = ['Sr.No', 'InvoiceId','EventId', 'NameOfOrganisation', 'NameofEvent',
    'Intervention', 'Component', 'EventStatus', 'NoOfMSMEAttended',
    'InvoiceStatus', 'RatePerMSME', 'Total', 'GSTType', 'GSTPercent', 'TotalGST',
    'FinalTotal', 'PaymentDate', 'Mode','AmountPaid','UTRNumber','Action']

  @ViewChild(MatPaginator) pagination!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  term$ = new BehaviorSubject<string>('');
  codeSearch$ = new BehaviorSubject<any>(null);
  nameSearch$ = new BehaviorSubject<any>(null);
  searchText: string = '';
  codeSearchKey: string = '';
  nameSearchKey: string = '';

  allrecord: any[] = [];

  EventList: any[] = [];

  length: number = 0;
  pageSize: number = 20;
  displayedData: any[] = [];
  reportData: any[] = [];
  userType = sessionStorage.getItem('UserType');
  dicUser = sessionStorage.getItem('dicUserName');
  mssidcUser = sessionStorage.getItem('mssidcUserName');

  pageSizeOptions: number[] = [10, 20, 50, 100];
  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;
  pageIndex = 0;
  pageEvent!: PageEvent;
  DtoPagination =
    {
      "DistrictCode": !isNaN(parseInt(sessionStorage.getItem("districtCode") || "", 10)) ? parseInt(sessionStorage.getItem("districtCode") || "", 10) : '', 
      "UserName": '',
      "PageNumber": 1,
      "PageSize": 20,
      "SortColumn": "",
      "SortDirection": "",
      "SearchTerm": "",
      "SearchCol": ""
    }

  constructor(
    private apiService: ApiService, private router: Router, public dialog: MatDialog,
    private toastrService: ToastrService, public commonService: CommonService) { }

  form = new FormGroup({
    searchControl: new FormControl('', [Validators.pattern(this.commonService.searchFilter)])
  })

  async ngOnInit(): Promise<void> {
    this.DtoPagination.PageSize = 20;
    this.DtoPagination.SearchTerm = this.commonService.searchText;
  }

  ngAfterViewInit() {
    if (this.userType == 'MSSIDC') { 
      this.DtoPagination.DistrictCode = "";
      this.DtoPagination.UserName = this.mssidcUser!;
      this.loadData();
    }
    else if (this.userType == 'DIC') {
      this.DtoPagination.DistrictCode = !isNaN(parseInt(sessionStorage.getItem("districtCode") || "", 10)) ? parseInt(sessionStorage.getItem("districtCode") || "", 10) : '',
      this.DtoPagination.UserName = this.dicUser!;
      this.loadData();
    } 
  }

  loadData() {
    if (!this.pagination) return;

    // Unsubscribe from previous subscription to prevent multiple API calls
    this.loadDataSubscription.unsubscribe();

    // Reset subscription with a new request
    this.loadDataSubscription = merge(
      this.sort.sortChange.pipe(takeUntil(this.destroy$)),
      this.term$.pipe(debounceTime(1100), distinctUntilChanged(), takeUntil(this.destroy$)),
      this.pagination.page.pipe(takeUntil(this.destroy$))
    )
      .pipe(
        filter(searchTerm => searchTerm != null),
        switchMap(() => {
          this.pagination.pageIndex = 0;
          this.DtoPagination.SortColumn = this.sort.active;
          this.DtoPagination.SortDirection = this.sort.direction;
          this.DtoPagination.SearchCol = this.commonService.searchText;

          return this.apiService.getRequest(API_ENDPOINTS.MASTERS.INVOICE.GETCOMPLETEDINVOICElIST, this.DtoPagination)
            .pipe(catchError(() => of(null)));
        }),
        map(resp => {
          if (resp && resp.status) {
            this.length = resp['totalRecords'];
          }
          return resp?.data || {};
        })
      )
      .subscribe(data => {
        this.dataSource = data;
        this.adjustPaginator();
      });
  }


  //loadAllData() {
  //  const DtoPagination = {
  //    DistrictCode: !isNaN(parseInt(sessionStorage.getItem("districtCode") || "", 10)) ? parseInt(sessionStorage.getItem("districtCode") || "", 10) : '',
  //    PageNumber: 1,
  //    PageSize: 9999999,
  //    SortColumn: "",
  //    SortDirection: "",
  //    SearchTerm: "",
  //    SearchCol: this.commonService.searchText,
  //  };

  //  if (!this.pagination) return;

  //  // Unsubscribe from previous subscription to prevent multiple API calls
  //  this.loadDataSubscription.unsubscribe();

  //  // Reset subscription with a new request
  //  this.loadDataSubscription = merge(
  //    this.sort.sortChange.pipe(takeUntil(this.destroy$)),
  //    this.term$.pipe(debounceTime(1100), distinctUntilChanged(), takeUntil(this.destroy$)),
  //    this.pagination.page.pipe(takeUntil(this.destroy$))
  //  )
  //    .pipe(
  //      filter(searchTerm => searchTerm != null),
  //      switchMap(() => {
  //        this.pagination.pageIndex = 0;
  //        this.DtoPagination.SortColumn = this.sort.active;
  //        this.DtoPagination.SortDirection = this.sort.direction;
  //        this.DtoPagination.SearchCol = this.commonService.searchText;

  //        return this.apiService.getRequest(API_ENDPOINTS.MASTERS.INVOICE.GETCOMPLETEDINVOICElIST, DtoPagination)
  //          .pipe(catchError(() => of(null)));
  //      }),
  //      map(resp => {
  //        if (resp && resp.status) {
  //          this.allrecord = resp.data;
  //          this.length = resp['totalRecords'];
  //        }
  //        return resp?.data || {};
  //      })
  //    )
  //    .subscribe(data => {
  //      this.dataSource = data;
  //      this.adjustPaginator();
  //    });
  //}

  ngOnDestroy() {
    this.loadDataSubscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  adjustPaginator() {
    const totalPages = Math.ceil(this.length / this.pageSize);

    // If the current page index is greater than or equal to total pages, move to the last page
    if (this.pageIndex >= totalPages) {
      this.pageIndex = totalPages - 1; // Set to the last valid page
      this.DtoPagination.PageNumber = this.pageIndex + 1; // Update for 1-based pagination
    }

    // Update the paginator with the adjusted page index
    this.pagination.pageIndex = this.pageIndex;
  }  

  onSearchChange(e: any) {
    this.DtoPagination.SearchTerm = e.target.value;
    this.DtoPagination.PageNumber = 1;
    this.loadData();
  }

  onPageChange(e: PageEvent) {
    this.pageEvent = e;
    this.length = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;

    this.DtoPagination.PageNumber = e.pageIndex + 1;
    this.DtoPagination.PageSize = e.pageSize;
    this.loadData();
  }

  resetPage() {
    this.DtoPagination.SearchTerm = "";
    this.DtoPagination.SearchCol = this.commonService.searchText;
    this.loadData();
  }

  onSearchClick(searchValue: string): void {
    const searchControl = this.form.get('searchControl');
    searchControl?.markAsTouched();

    if (searchControl?.valid && searchValue.trim() !== '') {
      this.DtoPagination.SearchTerm = searchValue.trim();
      this.DtoPagination.SearchCol = this.commonService.searchText;
      this.loadData();
    }
  }

  exportToExcel(): void {
    const fileName = 'Invoice_List.xlsx';
    const DtoPagination = {
      PageNumber: 1,
      PageSize: 9999999,
      SortColumn: "",
      SortDirection: "",
      SearchTerm: "",
      SearchCol: this.commonService.searchText,
      DistrictCode: "",
      UserName:""
    };

    if (this.userType == 'MSSIDC') {
      DtoPagination.DistrictCode = "";
      DtoPagination.UserName = this.mssidcUser!;
    }
    else if (this.userType == 'DIC') {
      DtoPagination.DistrictCode = sessionStorage.getItem("districtCode")!;
      DtoPagination.UserName = this.dicUser!;
    }

    this.apiService.getRequest(API_ENDPOINTS.MASTERS.INVOICE.GETCOMPLETEDINVOICElIST, DtoPagination).subscribe(
      result => {
        if (result.status) {
          this.allrecord = result.data;
          if (!this.allrecord) {
            this.toastrService.error('No data available to export.');
            return;
          }
        }
      });  

    const excelData = this.allrecord.map((item, index) => ({
      'Sr. No': index + 1,
      'Invoice Id': item.invoiceID,
      'Event Id': item.eventId,
      'Name Of Organisation': item.nameOfOrganisation,
      'Name of Event': item.eventName,
      'Intervention': item.interventionName,
      'Component': item.interestName,
      'Event Status': item.eventStatus,
      'Invoice Status': item.invoiceStatus,
      'Total count of Verified MSME Attended': item.noOfMSMEAttended,
      'RatePerMSME': item.ratePerMSME,
      'Total': item.total,
      'CGST': item.cgst,
      'SGST': item.sgst,
      'IGST': item.igst,
      'Total GST': item.totalGST,
      'Final Total': item.finalTotal,
      'Payment Date': item.paymentDate,
      'Mode': item.mode,
      'UTR Number': item.utrNumber,
      'Amount paid by department': item.amountPaid,
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);

    const columnWidths = [
      { wch: 10 }, // Sr. No
      { wch: 30 }, // Name of Event
      { wch: 20 }, // Intervention
      { wch: 25 }, // Component
      { wch: 15 }, // Event Status
      { wch: 50 }, // Count of MSME attended the event (Verified/Unverified)
      { wch: 20 }, // Invoice Status
    ];
    worksheet['!cols'] = columnWidths;

    const workbook: XLSX.WorkBook = {
      Sheets: { 'Invoice List': worksheet },
      SheetNames: ['Invoice List'],
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });

    const data: Blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });

    saveAs(data, fileName);
    this.toastrService.success('Excel exported successfully!');
  }

  saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });
    saveAs(data, fileName);
  }

  openFilePreviewDialog(fileName: string, filePath: string): void {
    this.apiService.getFilePreview(filePath).subscribe({
      next: (fileUrl) => {
        const dialogRef = this.dialog.open(PreviewfileComponent, {
          width: '80%',
          height: '80',
          data: { fileUrl, fileName }
        });
      }
    });
  }
  exportToPDF(): void {
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4',
    });

    const columns = [
      'Sr. No',
      'Invoice Id',
      'Event Id',
      'Name Of Organisation',
      'Name of Event',
      'Intervention',
      'Component',
      'Event Status',
      'Invoice Status',
      'Verified MSMEs',
      'RatePerMSME',
      'Total',
      'CGST',
      'SGST',
      'IGST',
      'Total GST',
      'Final Total',
      'Payment Date',
      'Mode',
      'UTR Number',
      'Amount Paid',
    ];

     

    // Ensure data exists
    if (!this.allrecord || this.allrecord.length === 0) {
      this.toastrService.warning('No data to export!');
      return;
    }

    const rows = this.allrecord.map((item, index) => [
      index + 1,
      item.invoiceID || '',
      item.eventId || '',
      item.nameOfOrganisation || '',
      item.eventName || '',
      item.interventionName || '',
      item.interestName || '',
      item.eventStatus || '',
      item.invoiceStatus || '',
      item.noOfMSMEAttended || '',
      item.ratePerMSME || '',
      item.total || '',
      item.cgst || '',
      item.sgst || '',
      item.igst || '',
      item.totalGST || '',
      item.finalTotal || '',
      item.paymentDate || '',
      item.mode || '',
      item.utrNumber || '',
      item.amountPaid || '',
    ]);

    //doc.text('Completed Invoice Report List', 14, 15);

    autoTable(doc, {
      head: [columns],
      body: rows,
      startY: 20,
      theme: 'striped',
      styles: {
        fontSize: 5.5,
        cellPadding: 1,
        overflow: 'linebreak',
      },
      headStyles: {
        fillColor: [22, 160, 133],
        fontSize: 6,
        halign: 'center',
      },
      alternateRowStyles: { fillColor: [245, 245, 245] },
      margin: { top: 20, left: 5, right: 5 },
      didDrawPage: function (data) {
        doc.setFontSize(10);
        doc.text('Invoice_List', data.settings.margin.left, 10);
      },
    });

    doc.save('Invoice_List.pdf');
    this.toastrService.success('PDF exported successfully!');
  }


  ViewInvoiceDetails(eventId: string) {
    sessionStorage.setItem("EventId", eventId);
    this.router.navigate(['/viewinvoicedetails']);
  }
}

